import { render, staticRenderFns } from "./GameCard.vue?vue&type=template&id=73df1ee4&scoped=true&"
import script from "./GameCard.vue?vue&type=script&lang=js&"
export * from "./GameCard.vue?vue&type=script&lang=js&"
import style0 from "./GameCard.vue?vue&type=style&index=0&id=73df1ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73df1ee4",
  null
  
)

export default component.exports